import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { track } from "@/lib/api";

export const StickyCTA = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 650);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <div
      className={`fixed bottom-4 inset-x-4 z-40 md:hidden transition-transform duration-500 ease-out ${
        show ? "translate-y-0" : "translate-y-28"
      }`}
    >
      <Link
        to="/book"
        data-testid="sticky-book-cta"
        onClick={() => track("cta_book_click", { label: "sticky" })}
        className="block text-center bg-ink text-paper rounded-full py-4 text-sm font-semibold tracking-wide shadow-lg shadow-ink/20 active:bg-pine transition-colors duration-300"
      >
        Book a First Walk — £60
      </Link>
    </div>
  );
};
